module.exports = __webpack_public_path__ + "img/savings.5d13810.png";